import { render, staticRenderFns } from "./AppNotLoaded.vue?vue&type=template&id=7e453ae4&scoped=true&"
var script = {}
import style0 from "./AppNotLoaded.vue?vue&type=style&index=0&id=7e453ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e453ae4",
  null
  
)

export default component.exports